import type { ApiErrorPayload } from './http.types';

export class ApiError extends Error {
  readonly statusCode: number;
  readonly messages: string[];
  readonly error?: string;
  /** Copie du payload d'erreur complet ; `{}` si le corps reçu n'est pas un objet. */
  readonly details: Record<string, unknown>;
  readonly isApiError = true;

  constructor(payload: ApiErrorPayload, statusCode: number) {
    const body: Partial<ApiErrorPayload> =
      typeof payload === 'object' && payload !== null && !Array.isArray(payload) ? payload : {};
    const messages =
      typeof body.message === 'string'
        ? [body.message]
        : Array.isArray(body.message)
          ? body.message
          : [];
    super(messages[0] ?? 'An error occurred');
    this.name = 'ApiError';
    this.statusCode = statusCode;
    this.messages = messages;
    this.error = body.error;
    this.details = { ...body };
    Object.setPrototypeOf(this, ApiError.prototype);
  }

  get isClientError(): boolean {
    return this.statusCode >= 400 && this.statusCode < 500;
  }

  get isServerError(): boolean {
    return this.statusCode >= 500;
  }

  get isUnauthorized(): boolean {
    return this.statusCode === 401;
  }

  get isForbidden(): boolean {
    return this.statusCode === 403;
  }

  get isNotFound(): boolean {
    return this.statusCode === 404;
  }

  get isValidationError(): boolean {
    return this.statusCode === 400 || this.statusCode === 422;
  }

  static isApiError(error: unknown): error is ApiError {
    return error instanceof ApiError;
  }
}
